






































































import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { OptionToSelect } from '~/utils/types/ProductPage';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import PurchaseOptionCard from './PurchaseOptionCard.vue';
import { Pagination, Navigation } from 'swiper'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { getIsBook } from '~/utils/solepro/products';
import PaymentMethodsIcons from '../PaymentMethodsIcons.vue';
import { equalizePurchaseSlides, observeScalapay } from '~/utils/helpers/solepro/product';
import BundlePurchaseOptionCard from './BundlePurchaseOptionCard.vue';
import { calcolaBoxInWidth } from '~/utils/solepro/functions';


SwiperCore.use([Pagination, Navigation])
export default defineComponent({
    props: {
        optionBlock: {
            type: Object as PropType<OptionToSelect>,
            required: true
        },
        product: {
            type: Object as PropType<ProductForProductPageType>,
            required: true
        },
        optionIndex: {
            type: Number,
            default: 0
        },
        showFrequencies:{
            type: Boolean,
            deafault: true
        },
        showSuggestedSku:{
            type: Boolean,
            deafault: false
        },
       moreCards:{
            type: Array as PropType<any>,
            default: ()=>{ return []}
        },
        moreOptions:{
            type: Object as PropType<any>,
            default: ()=>{ return {}}
        }
    },
    data() {
        return {
            isSSR: true,
            swiperInstance: null,
        }
    },
    components: {
        PurchaseOptionCard,
        BundlePurchaseOptionCard,
        Swiper,
        SwiperSlide,
        PaymentMethodsIcons
    },
    setup(props) {
        const cardsQty = ref(0)
        const mdMaxWidth = computed(()=>{
            if(process.client && cardsQty.value>0){
              const numeroMaxCards = calcolaBoxInWidth(document.querySelector('.section-purchase-options').getBoundingClientRect().width-40-53)
              const max =  numeroMaxCards * 340 + (numeroMaxCards - 1) * 20
              const effective = cardsQty.value>0 ? cardsQty.value*340 +(cardsQty.value - 1) * 20 : 0
              return Math.min(max, effective)
            }else return null
        })
        const showNavigation = computed(()=>{
            if(process.client && cardsQty.value>0){
              const numeroMaxCards = calcolaBoxInWidth(document.querySelector('.section-purchase-options').getBoundingClientRect().width-40-53)
              return cardsQty.value > numeroMaxCards
            }else return null
        })
        const swiperProps = {
            modules: [Navigation, Pagination],
            slideClass: "slide",
            spaceBetween: 20,
            navigation: {
                prevEl: '.section-purchase-options .navigation-prev',
                nextEl: '.section-purchase-options .navigation-next',
            },
            pagination: false,
            slidesPerView: 3,
            slidesPerGroup: 3,
            direction: "horizontal",
            loop: false, // Disabilita il loop
            breakpoints: {
                0: { // Inizia da 0px fino a 10247px
                    enabled: false,
                    slidesPerView: 'auto', // Mostra una slide per riga (o auto a seconda del contenuto)
                    freeMode: true, // Permette lo scroll libero senza snap delle slide
                    navigation: false, // Disabilita le frecce
                    allowTouchMove: true, // Permette lo scorrimento
                    grabCursor: false, // Non mostra il cursore di "mano"
                    direction: "vertical",
                },
                1024: {
                    enabled: true,
                    slidesPerView: 'auto',
                    direction: "horizontal",
                    allowTouchMove: true,
                    grabCursor: true,
                    freeMode: false,

                }
            },
        }
        return {
            cardsQty,
            showNavigation,
            swiperProps,
            mdMaxWidth,
            isBook: getIsBook(props.product),
        }
    },
    mounted() {
        this.isSSR = false;
        this.cardsQty = Array.from(document.querySelectorAll('[data-component="productPurchaseOptions"]')).length

    },
    watch: {
        cardsQty: {
            handler(newVal) {
                const $th = this as any; //vscode trick @TODO adjustr linter
                if (newVal > 0 && $th.swiperInstance) {
                    setTimeout(() => {
                        equalizePurchaseSlides($th.swiperInstance);
                        $th.swiperInstance.update();
                        console.log('swiperInstance updated');
                    }, 100)

                }
            },
            immediate: true
        }
    },
    methods: {
         calculateHeights(swiper){
            const $th = this as any; //vscode trick @TODO adjustr linter
            observeScalapay(swiper.$el[0], ()=> $th.$nextTick(()=>equalizePurchaseSlides(swiper)))
            $th.nextTick(() => {
                equalizePurchaseSlides(swiper);
            });
        },
        afterInit(swiper) {
            if(window.innerWidth<1024) return;
            const $th = this as any; //vscode trick @TODO adjustr linter
            $th.swiperInstance = swiper;
            observeScalapay(swiper.$el[0], ()=>setTimeout(()=>equalizePurchaseSlides(swiper, false),100))
            setTimeout(() => {
                equalizePurchaseSlides(swiper);
            }, 100);
            /** Fallback for observer failing @TODO sistemare! fa schifissimo */
            setTimeout(() => {
                equalizePurchaseSlides(swiper, false);
            }, 1000);
        },
        onSwiperResize(swiper) {
            equalizePurchaseSlides(swiper);
            console.log('swiper resized');
        },
         changeFrequency(product, val) {
            const $th = this as any; //vscode trick @TODO adjustr linter
            //this.paymentFrequenciesChoosen[product.sku] = val;
            $th.$forceUpdate()
        },
        
    }
})
